import { create } from "zustand";
import { LeadsModalModeEnum } from '../api/models/Enums';
import { devtools } from "zustand/middleware";


export interface AuthStoreProps {
  user: any,
  setUser: (user: any) => void,
}

const useAuthStore = create<AuthStoreProps>()(devtools((set) => ({
  user: null,
  setUser: (user) => set(() => ({ user })),
}),
  { name: "AuthStore" }
));
// useAuthStore.subscribe((state) => {
// });


export default useAuthStore;
